import script from "./RejectionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RejectionModal.vue?vue&type=script&setup=true&lang=js"

import "./RejectionModal.vue?vue&type=style&index=0&id=d6f0d3b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6f0d3b0"]])

export default __exports__